<template>
  <div class="exam-detail">
    <div class="exam-detail-banner">
      <img src="@/assets/studyClass/dp-xx-ba4.png" alt />
    </div>
    <div class="exam-detail-score">
      <p>成绩：{{msg.score}}</p>
      <p>合格/总分：60分/100分</p>
    </div>
    <div class="exam-detail-shows">
      <p>考试时间：{{msg.starttime | times}}</p>
      <p>交卷时间：{{msg.endtime | times}}</p>
      <p>考试用时：{{msg.usetime}}</p>
      <p>是否阅卷：已阅</p>
    </div>
    <div class="exam-detail-explain">
      <p>答题卡</p>
      <label>
        <span>正确</span>
        <span class="correct"></span>
      </label>
      <label>
        <span>错误</span>
        <span class="error"></span>
      </label>
      <label>
        <span>未做</span>
        <span class="not"></span>
      </label>
    </div>
    <div class="exam-detail-anwser">
      <span
        v-for="(data,i) in history"
        :key="i"
        :class="judgeClass(data.state)"
        @click="goLookDetail(data.Examid)"
      >{{i+1}}</span>
    </div>
    <div class="exam-detail-posi">
      <button @click="goExam()">重新考试</button>
      <button @click="goMain()">返回主页面</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: {},
      history: []
    };
  },
  mounted() {
    this.getMsg();
  },
  methods: {
    getMsg() {
      this.axios
        .get("/api/Index/GetResult", {
          params: {
            userid: sessionStorage.getItem("id"),
            studyid: this.$route.query.studyId
          }
        })
        .then(e => {
          if (e.data.code == 0) {
            console.log(e.data);
            if (e.data.msg) {
              this.msg = e.data.msg;
            }
            if (e.data.History.length > 0) {
              this.history = e.data.History;
            }
          }
        });
    },
    judgeClass(state) {
      let className = "";
      switch (state) {
        case 0:
          className = "correct";
          break;

        case 1:
          className = "error";
          break;

        case 2:
          className = "not";
          break;
        default:
          break;
      }

      return className;
    },
    goLookDetail(Examid) {
      this.$router.push({
        path: "/study/lookError",
        query: {
          title: "学习班测试错题",
          id: Examid
        } 
      });
    },
    goExam(){
      this.$router.push({
        path:'/study/exam',
        query:{
          title:'学习班测试',
          studyId:this.$route.query.studyId
        }
      })
    },
    goMain(){
      this.$router.go(-2)
      //  this.$router.push({
      //   path:'/study/myClass',
      //   query:{
      //     title:'我的学习班'
      //   }
      // })
    }
  },
  computed: {}
};
</script>
<style lang='scss' scoped>
.exam-detail {
  &-posi{
    button{
      &:nth-child(1){
        border-right: .01rem solid #eeeeee;
      }
      width: 50%;
      border: none;
      background: none;
      color: #999999;
    }
    position: fixed;
    width: 100%;
    line-height: 3;
    background: #fff;
    border-top: .01rem solid #f9f9f9;
    text-align: center;
    bottom: 0;
  }
  &-anwser {
    span {
      text-align: center;
      border-radius: 50%;
      width: 0.6rem;
      height: 0.6rem;
      line-height: 2;
      margin: 0.2rem 0;
    }
    background: #fff;
    padding: 0.2rem;
    display: grid;
    grid-template-columns: 16.6% 16.6% 16.6% 16.6% 16.6% 16.6%;
    padding-bottom: 1rem;
  }
  .correct {
    background: #42c671;
    color: #029d3a;
  }
  .error {
    background: #fa8181;
    color: #e80505;
  }
  .not {
    background: #cccccc;
    color: #999999;
  }
  &-explain {
    label {
      span {
        &:nth-child(2) {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
          margin-right: 0.2rem;
          margin-left: 0.05rem;
        }
      }
      &:nth-child(2) {
        margin-left: 2.5rem;
      }
      display: flex;
      align-items: center;
      font-size: 0.24rem;
    }
    margin-top: 0.2rem;
    background: #fff;
    padding: 0.2rem;
    display: flex;
    align-items: center;
  }
  &-shows {
    p {
      padding: 0.2rem;
      background: #fff;
      border-bottom: 0.01rem solid #e6e6e6;
    }
  }
  &-score {
    p {
      &:nth-child(1) {
        color: #ea1c08;
        font-size: 0.54rem;
        font-weight: bold;
      }
    }
    position: absolute;
    top: 1.4rem;
    left: 0.4rem;
  }
  &-banner {
    img {
      width: 100%;
    }
    line-height: 0;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>